
import Modal from '~/components/Shared/Modal/index.vue'
import VideoPlayer from '~/components/VideoPlayer/Player.vue'
import { convertToSlug } from '~/helpers/generate-slug'
export default {
  data() {
    return {
      showYoutube: '',
      showVideo: false,
    }
  },
  props: {
    product: {
      default: () => {
        return {
          imagePath: '',
          comments: [],
        }
      },
    },
  },
  computed: {
    commentLength() {
      return this.product.comments === null ? 0 : this.product.comments.length
    },
    starAvg() {
      if (this.product.comments === null) return 0
      if (this.product.comments.length === 0) return 0
      const length =
        this.product.comments === null ? 0 : this.product.comments.length
      const totalStar = this.product.comments.reduce(
        (sum, { point }) => sum + point,
        0
      )
      return Math.round(totalStar / length)
    },
  },
  components: { Modal, VideoPlayer },
  methods: {
    convertToSlug,
    GO_TO_LIST() {
      document
        .getElementById('seances-list')
        .scrollIntoView({ behavior: 'smooth' })
    },
    SET_SOURCE() {
      if (this.product.videoPath.includes('www.youtube.com/watch?v=')) {
        this.showYoutube = this.product.videoPath.split(
          'www.youtube.com/watch?v='
        )[1]
      }
    },
  },
  mounted() {
    this.SET_SOURCE()
  },
}
